export interface RegisterClientParams {
    nombre_completo: string;
    direccion: string;
    curp: string;
    email: string;
    whatsapp_number: string;
    slug?: string;
}

export interface RegisterClientResponse {
    message: string;
    client: {
        id: string;
        created_at: string;
        [key: string]: any;
    };
}

export const registerClient = async (params: RegisterClientParams): Promise<RegisterClientResponse> => {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
    const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

    if (!supabaseUrl || !anonKey) {
        throw new Error("Supabase environment variables are missing.");
    }

    const response = await fetch(`${supabaseUrl}/functions/v1/registrarUsuario`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${anonKey}`,
            apikey: anonKey,
        },
        body: JSON.stringify(params),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.error || "Error al registrar cliente");
    }

    return data;
};
